import { isAxiosError } from "axios";
import i18n, { t } from "i18next";
import axios from "../lib/axios";
import { DocumentSendRequestWithNames } from "../types";

export const createDocumentSendRequest = async (
  documentType: number,
  year: string,
  month: string,
  emailAddress: string,
): Promise<void> => {
  try {
    await axios.post(
      "/api/document-send-requests",
      {
        type: documentType,
        date: `${year}-${month}-01`,
        emailAddress,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
};

export const getDocumentSendRequest = async (
  mode: number,
): Promise<DocumentSendRequestWithNames[]> => {
  try {
    const { data } = await axios.get<DocumentSendRequestWithNames[]>(
      "/api/document-send-requests",
      {
        params: {
          mode,
        },
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return data;
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
};

export const realizeDocumentSendRequest = async (
  id: number,
  comment: string | null,
): Promise<void> => {
  try {
    await axios.post(
      `/api/document-send-requests/${id}/realize`,
      {
        comment,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
};

export const deleteDocumentSendRequest = async (id: number): Promise<void> => {
  try {
    await axios.delete(`/api/document-send-requests/${id}`, {
      headers: {
        "Accept-Language": i18n.language,
      },
    });
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
};
